<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        persistent
        title="Permissões"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade"
                    :value="centroCusto.unidadeNomeFantasia"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    :value="centroCusto.infraestruturaNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Setor"
                    :value="centroCusto.setorNome"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-area title="Grupos">
            <rkm-table
                :fields="fields"
                :items="grupos"
                @filtered="gruposFiltered = $event"
            >
                <template #head(permiteRequisitar)>
                    <rkm-form-checkbox
                        :disabled="disabledSelectAll"
                        :indeterminate="indeterminate"
                        :value="true"
                        @change="toggleSelectionAll"
                        v-model="selectedAll"
                    />
                </template>

                <template v-slot:cell(quantidadeMateriaisPermitidos)="{ item }">
                    {{ item.materiais.filter(m => m.permiteRequisitar).length }}/{{ item.materiais.length }}
                </template>

                <template v-slot:cell(permiteRequisitar)="{ item }">
                    <rkm-form-checkbox
                        :disabled="item.materiais.length == 0"
                        :value="true"
                        @change="item.materiais.map(m => m.permiteRequisitar = $event)"
                        v-model="item.permiteRequisitar"
                        v-rkm-tooltip.hover="item.materiais.length == 0 ? 'Este grupo não possui materiais' : ''"
                    />
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="$refs.ModalMaterial.open(item)"
                        color="primary"
                        :disabled="item.materiais.length == 0"
                        small
                        :title="item.materiais.length == 0 ? 'Este grupo não possui materiais' : 'Configurar permissões de materiais'"
                    >
                        <rkm-icon icon="cog" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.ModalImportacao.open(centroCusto)"
                authorize="storePermissoes-almoxarifado-requisicao-pendente-permissao"
                color="primary"
            >
                Importar permissões de outro setor
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>

        <ModalMaterial ref="ModalMaterial" />

        <ModalImportacao
            @save="handleExit"
            ref="ModalImportacao"
        />
    </rkm-modal>
</template>

<script>
// Components
import ModalMaterial from './components/material/Modal'
import ModalImportacao from './components/importacao/Modal'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Others.
import { repository, object, stringCase } from '@/mixins'

export default {
    components: { ModalMaterial, ModalImportacao },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'permiteRequisitar',
                    class: 'col-min text-center'
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
                {
                    key: 'quantidadeMateriaisPermitidos',
                    label: 'Materiais permitidos',
                    class: 'col-min text-center'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
        disabledSelectAll() {

            return !this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .find(g => g.materiais.length > 0)
        }
    },
    created() {

        this.repositories = {
            permissao: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao.permissao')
        }
    },
    data: () => ({
        centroCusto: {},
        grupos: [],
        gruposFiltered: [],
        indeterminate: false,
        selectedAll: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(centroCusto) {

            this.centroCusto = centroCusto

            this.load()

            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.permissao.getMateriais(this.centroCusto.id)
                .then(({ data }) => {

                    this.grupos = data
                    this.gruposFiltered = this.clone(this.grupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        toggleSelectionAll(permitido) {

            this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .filter(g => g.materiais.length > 0)
                .map(grupo => {

                    grupo.permiteRequisitar = permitido
                    grupo.materiais.map(m => m.permiteRequisitar = permitido)
                })
        },
        handleExit() {

            this.grupos = []
            this.gruposFiltered = []
            this.$refs.Modal.hide()
        },
        save() {

            this.setLoading()

            this.repositories.permissao.storePermissoes(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                    this.handleExit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const materiais = []

            this.grupos.forEach(g => g.materiais
                .filter(m => m.permiteRequisitar)
                .forEach(m => materiais.push({
                    id: m.id,
                    estoqueMaximo: isNaN(parseInt(m.estoqueMaximo)) ? null : parseInt(m.estoqueMaximo),
                }))
            )

            const data = {
                centroCustoRequisitanteId: this.centroCusto.id,
                materiais,
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        handleSelectAllStatus() {

            this.indeterminate = false

            const gruposFiltered = this.grupos
                .filter(g => this.gruposFiltered.find(gf => gf.id === g.id))
                .filter(g => g.materiais.length > 0)

            const quantidadePermitida = gruposFiltered.filter(g => g.permiteRequisitar).length

            this.selectedAll = quantidadePermitida > 0 && quantidadePermitida == gruposFiltered.length

            if (quantidadePermitida > 0 && quantidadePermitida != gruposFiltered.length) {

                this.indeterminate = true
            }
        }
    },
    mixins: [repository, object, stringCase],
    watch: {
        grupos: {
            deep: true,
            handler() {

                this.handleSelectAllStatus()
            }
        },
        gruposFiltered() {

            this.handleSelectAllStatus()
        }
    }
}
</script>